module.exports = __webpack_public_path__ + "static/img/56-1.db90027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/56-1.jpg
// module id = JOUY
// module chunks = 0